import { Dialog, DialogContent } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import { Noteable } from '../../types/Note';
import NoteForm from './NoteForm';

interface INoteModalProps {
  isOpen: boolean;
  onCancel: () => void;
  uuid: string;
  noteable: Noteable;
  setNoteSnackbarMessage: Dispatch<SetStateAction<string | null>>;
  parentUuid?: string;
  setExpandedNoteUuid: (uuid: string | null) => void;
}

export default function NoteModal({ isOpen, onCancel, uuid, parentUuid, noteable, setNoteSnackbarMessage, setExpandedNoteUuid }: INoteModalProps) {
  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth>
      <NoteForm
        uuid={uuid}
        noteable={noteable}
        setExpandedNoteUuid={setExpandedNoteUuid}
        parentUuid={parentUuid}
        setNoteSnackbarMessage={setNoteSnackbarMessage}
        onCancel={onCancel}
      />
    </Dialog>
  );
}
